import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { SingleSelectDateFilterDefinition } from '@asset-metrix/portal-gateway-client-js';
import { SingleDatePicker } from '@asset-metrix/portal-ui';

import { useStore } from '../../store';
import { toDateString } from '../../utils/dateHelper';

export type SingleDatePickerFilterProps = {
  dateTimeFormatOptions?: Intl.DateTimeFormatOptions;
  filterData?: SingleSelectDateFilterDefinition;
  entityId: string;
  filterKey: string;
  isFetching?: boolean;
  clearable?: boolean;
  label?: ReactNode | ReactNode[];
};

export function SingleDatePickerFilter({
  clearable,
  dateTimeFormatOptions,
  filterData,
  entityId,
  filterKey,
  isFetching,
  label,
}: SingleDatePickerFilterProps) {
  const { t } = useTranslation();
  const setFilterSelectionValue = useStore(
    (state) => state.setFilterSelectionValue
  );

  return (
    <SingleDatePicker
      availableDates={filterData?.data
        .filter((d): d is NonNullable<typeof d> => d != null)
        .map((d) => new Date(Date.parse(d)))}
      dateTimeFormatOptions={
        // omit time constraints
        dateTimeFormatOptions
          ? {
              ...dateTimeFormatOptions,
              hour: undefined,
              minute: undefined,
            }
          : undefined
      }
      label={label ?? t('app.pageFilter.calendarFilter.defaultTitle')}
      value={
        filterData?.selection != null
          ? new Date(Date.parse(filterData.selection))
          : null
      }
      clearable={clearable}
      loading={isFetching}
      placeholder={t('app.pageFilter.calendarFilter.placeholder')}
      onChange={(date) => {
        if (filterData) {
          setFilterSelectionValue(
            entityId,
            filterKey,
            date != null ? toDateString(date) : undefined
          );
        }
      }}
    />
  );
}
